import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Form, Input, Row, Button } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/Common/withRouter";

// Images
import logodark from "../../assets/images/logo-yeta.png";
import logolight from "../../assets/images/logo-yeta.png";

// Actions Redux
import { 
    verifyTwoFactor as onVerifyTwoFactor ,
    resendTwoFactorCode as onResendTwoFactorCode
} from "store/actions";

const TwoFactor = (props) => {
  document.title = "Double authentification | YETA+";

  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.auth || {}); // safe

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, "");
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp.some((digit) => digit === "")) {
      alert("Veuillez saisir les 6 chiffres du code.");
      return;
    }

    const code = otp.join("");
    const tempToken = localStorage.getItem("tempToken"); // récupère le temp_token
    if (!tempToken) {
      alert("Token temporaire manquant. Veuillez vous reconnecter.");
      return;
    }

    // dispatch avec code et tempToken
    dispatch(onVerifyTwoFactor({ code, tempToken, history: props.router.navigate }));
  };

  const handleResendCode = (e) => {
    e.preventDefault();
    const tempToken = localStorage.getItem("tempToken");
    if (tempToken) {
      // dispatch pour renvoyer le code OTP si nécessaire
      dispatch(onResendTwoFactorCode(tempToken));
      
    } 
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5 text-muted">
              <Link to="/dashboard" className="d-block auth-logo">
                <img src={logodark} alt="" height="20" className="auth-logo-dark mx-auto" />
                <img src={logolight} alt="" height="20" className="auth-logo-light mx-auto" />
              </Link>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2 text-center">
                    <div className="avatar-md mx-auto">
                      <div className="avatar-title rounded-circle bg-light">
                        <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                      </div>
                    </div>

                    <div className="p-2 mt-4">
                      <h4>Vérifiez votre email</h4>
                      <p className="mb-5">
                        Veuillez saisir le code à 6 chiffres envoyé dans votre email.
                      </p>

                      <Form onSubmit={handleSubmit}>
                        <Row className="justify-content-center mb-3">
                          {otp.map((digit, index) => (
                            <Col key={index} className="col-2">
                              <Input
                                type="text"
                                className="form-control form-control-lg text-center two-step"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                ref={(el) => (inputsRef.current[index] = el)}
                              />
                            </Col>
                          ))}
                        </Row>

                        {error && <p className="text-danger">{String(error)}</p>}

                        <Button color="success" type="submit" className="w-100">
                          Confirmer
                        </Button>
                      </Form>

                      <div className="mt-4">
                        <p>
                          Vous n'avez pas reçu de code ?{" "}
                          <Link to="#" onClick={handleResendCode} className="fw-medium text-primary">
                            RENVOYER
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} YETA+. Développé avec{" "}
                  <i className="mdi mdi-heart text-danger"></i> par TECH ZENITH
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

TwoFactor.propTypes = {
  router: PropTypes.object,
};

export default withRouter(TwoFactor);
